import React, { useEffect } from "react";

// MUI
import { Tabs, Tab, Box, Divider } from "@mui/material";

// Components
import WinLossHistory from "./WinLossHistory";
import BidStatusSection from "./BidStatusSection";

// Hooks
import { useAppDispatch } from "../../redux/hooks/redux-hooks";

// Actions
import { fetchProjectBidStatusHistory } from "../../redux/actions/WinLossActions";
import { fetchProjectBidderDetails } from "../../redux/actions/BidderDetailActions";

// Config
import { projectBidStatusObj } from "../../utility/config";

type Props = {
  projectId: number;
  projectStatus: string;
  tenderMaturity: string;
};

const WinLossSection = ({
  projectId,
  projectStatus,
  tenderMaturity,
}: Props) => {
  const [activeTab, setActiveTab] = React.useState(0);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchProjectBidStatusHistory(projectId));
    dispatch(fetchProjectBidderDetails(projectId));
  }, [projectId, dispatch]);

  const handleTabChange = (event: any, newValue: any) => {
    setActiveTab(newValue);
  };

  return (
    <>
      <Divider sx={{ backgroundColor: "black" }} />
      <Tabs value={activeTab} onChange={handleTabChange} variant="fullWidth">
        <Tab label="Bid Status" />
        {projectStatus === projectBidStatusObj.approved && (
          <Tab label="History" />
        )}
      </Tabs>
      <Box p="1em">
        {activeTab === 0 && (
          <BidStatusSection
            projectId={projectId}
            projectStatus={projectStatus}
            tenderMaturity={tenderMaturity}
          />
        )}
        {activeTab === 1 && <WinLossHistory />}
      </Box>
    </>
  );
};

export default WinLossSection;
